import Alpine from "alpinejs";
import { cloud } from "../../lib/cloud"

/** Address Type is only an assumption of how the Address data structure will be structured  */
type Address = {
    id: string
    street: string
    state: string
    postalCode: string
    city: string
    country: string
}

type AddressValidate = {
    fullAddress: string,
    id: string
}

type LoqateAddressValidationResponse = {
    message: string[],
    status: string
    payload: AddressValidate[]
}

type LoqateAddressResponse = {
    message: string[],
    status: string
    payload: LoqateAddress[]
}

type LoqateAddress = {
    _type: "ValidatedAddressNz";
    fullAddress: string;
    country: string;
    postcode: string;
    street2: string | null;
    street: string;
    streetNumber: string;
    postal: string;
    postalType: string;
    postalNumber: string;
    buildingName: string;
    subdwelling: string;
    eid: string | null;
    lotNumber: string;
    flatUnitNumber: string;
    flatUnitType: string;
    floorLevelNumber: string;
    floorLevelType: string;
    streetSuffix: string;
    streetType: string;
    streetName: string;
    attributes: {
        ParcelId: string;
        CountryIso2: string;
        address_type: string;
        CountryIso3: string;
        DPID: string;
        regional_council_id: string;
        Latitude: string;
        source: string;
        City: string;
        Longitude: string;
        MeshblockId: string;
        ProvinceName: string;
        address_line2: string;
        address_line1: string;
        regional_council_name: string;
        ta_name: string;
        XCoordinate: string;
        ProvinceCode: string;
        ta_id: string;
        YCoordinate: string;
    };
    id: string;
    sourceOfTruth: string;
    rdNumber: string | null;
    deliveredTo: string;
    exception: string | null;
    suburb: string;
    townCity: string;
};


type AddressValidationProps = {
    address1?: string
    address2?: string
    city?: string
    zip?: string
    province_code?: string
    country?: string
}

const LOQATE_END_POINTS = {
    VALIDATE_ADDRESS: '/location/validate-address',
    RETRIEVE_ADDRESS: '/location/retrieve-address',
}

Alpine.data('addressValidation', (props: AddressValidationProps) => ({
    data: {},
    addressData: [] as AddressValidate[],
    status: '',
    debounceTimeout: null as NodeJS.Timeout | null,
    init() {
        /** setting the props to the data attribute above seems to have
         * the all the address attributes as undefined. 
         * 
         * Setting the data in the init function resolves this. 
         */
        this.data = { ...props }
    },

    debounce(callback: Function, delay = 500) {
        return (...args: any) => {
            if (this.debounceTimeout) {
                clearTimeout(this.debounceTimeout)
            }
            this.debounceTimeout = setTimeout(() => callback(...args), delay);
        };
    },

    /**
     * ctx = this
     * @param ctx 
     * @returns 
     */
    addressCallback(ctx: Alpine.AlpineComponent<{ fetch: () => void, data: { [key: string]: string }, status: string, addressData: AddressValidate[] }>) {
        const address = ctx?.data['address[address1]'];
        const country = ctx?.data['address[country]'];
        if (!address || !country) {
            ctx.status = 'No Address Or Country provided.';
            ctx.addressData = []
            return;
        }

        ctx.status = '';
        cloud.post<LoqateAddressValidationResponse, { country: string, fullAddress: string }>(LOQATE_END_POINTS.VALIDATE_ADDRESS, {
            country,
            fullAddress: address
        }).then(data => {
            if (!data?.payload.length) return;
            ctx.addressData = data?.payload
        })
    },


    handleSearch() {
        this.debounce(this.addressCallback)(this)
    },

    active: {
        [':data-ui']() {
            return this.addressData.length && 'focused'
        }
    },

    validate_address: {
        ['@input']() {
            this.debounce(this.addressCallback)(this)
            this.$el.focus()
        },
    },
    close: {
        ['@click']() {
            this.addressData = []
        },

    },
    select_address: {
        ['@click']() {
            const id = this.$el.dataset.id;
            if (!id) return;
            cloud.post<LoqateAddressResponse, { id: string }>(LOQATE_END_POINTS.RETRIEVE_ADDRESS, {
                id
            }).then((response) => {
                const selectedAddress = response?.payload
                if (!selectedAddress?.length) return;
                const address = selectedAddress.pop()
                if (!address) return;

                this.data = {
                    'address[address1]': address.attributes.address_line1,
                    'address[address2]': address.attributes?.address_line2 ?? address.townCity,
                    'address[city]': address.attributes.City,
                    'address[zip]': address.postcode,
                    'address[province_code]': address.attributes.ProvinceCode,
                    'address[country]': address.country,
                }

                this.addressData = []
                this.status = ''
            })
        },
    }
}))